
import { Badge } from "@/components/ui/badge";

interface PartSpecificationsProps {
  category: string;
  subcategory: string;
}

const PartSpecifications = ({ category, subcategory }: PartSpecificationsProps) => {
  return (
    <div className="mb-6">
      <h2 className="text-xl font-semibold mb-4">Specifications</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="bg-card border rounded-lg p-4">
          <h3 className="font-medium mb-2">Category</h3>
          <Badge className="capitalize">{category}</Badge>
        </div>
        <div className="bg-card border rounded-lg p-4">
          <h3 className="font-medium mb-2">Subcategory</h3>
          <Badge className="capitalize">{subcategory}</Badge>
        </div>
      </div>
    </div>
  );
};

export default PartSpecifications;
